export const EXCLAMATION_ICON_MARGIN = '1px 8px 0 0';
export const IMAGE_BORDER_RADIUS = '0';
export const CONTAINER_PADDING = '0.5rem';
